import { render } from "./WelcomeExperience.vue?vue&type=template&id=77df335a"
import script from "./WelcomeExperience.vue?vue&type=script&lang=js"
export * from "./WelcomeExperience.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__